/**
 * 팀 운영(team-settings) 창의 보조 windowStore 탭 키 — '팀 근무'(team-work) 창 제거 후
 * 승인 알림 딥링크가 팀 운영으로 착지하기 위한 단일 정본.
 *
 * - TEAM_SETTINGS_VIEW_TAB_KEY: [구성원]/[승인] 상위 세그먼트 (TeamSettingsPage 소비)
 * - TEAM_APPROVALS_TAB_KEY: 승인 서브탭 (widgets/team-approvals 소비, 구 'team-work' 키 후신)
 *
 * 쓰기는 pages/MainPage 의 applyViewNavigation(딥링크 브리지)과 각 소비 컴포넌트의
 * 탭 전환이 담당한다. TEAM_APPROVALS_TAB_KEY 는 Providers 의 pruneUnknownWindowIds
 * 허용 목록에 포함되어 리로드 후에도 탭 선택이 유지된다.
 */
export const TEAM_SETTINGS_VIEW_TAB_KEY = 'team-settings-view';
export const TEAM_APPROVALS_TAB_KEY = 'team-approvals';
export const TEAM_RETRO_AXIS_TAB_KEY = 'team-retro-axis';
export const TEAM_RETRO_CAMPAIGN_TAB_KEY = 'team-retro-campaign';

/**
 * TeamOpsConsole 상위 뷰 어휘 — windowStore 복원/딥링크가 같은 정본을 사용한다.
 *
 * ⚠️ 아래 두 목록은 함께 갱신해야 한다 — union 을 빠뜨리면 Set 타입 인자가 좁혀져 있어
 * tsc 가 잡지만, Set 을 빠뜨리면 tsc 는 통과하고 리로드 복원·딥링크 착지만 조용히 깨진다.
 */
export type TeamSettingsViewTabId =
  'members' | 'approvals' | 'statistics' | 'weekly-report' | 'budget' | 'settings' | 'retro';

const TEAM_SETTINGS_VIEW_TABS = new Set<TeamSettingsViewTabId>([
  'members',
  'approvals',
  'statistics',
  'weekly-report',
  'budget',
  'settings',
  'retro',
]);

export function isTeamSettingsViewTab(v: unknown): v is TeamSettingsViewTabId {
  // Set<TeamSettingsViewTabId>.has 는 인자를 union 으로 좁히므로 unknown 조회는 Set<string> 캐스트로.
  return typeof v === 'string' && (TEAM_SETTINGS_VIEW_TABS as Set<string>).has(v);
}

/**
 * 승인 서브탭 어휘 — 알림 딥링크 context.tab 과 동일 (getDeepLink 계약)
 * company-offday: HR_MANAGEMENT capability 보유자가 범위 토글을 전사로 둔 비근무(팀 범위 team-offday 와 구분)
 * company-corrections: 같은 capability 의 전사 범위 정정(팀 범위 corrections 와 구분)
 * company-leave: 같은 capability 의 휴가 대리 승인 대기(팀 범위 team-leave 와 구분)
 * company-all: 전사 범위 + 종류 전체 — 좌측 요약 '승인 대기 N건 전체' 착지점
 *
 * ⚠️ 아래 두 목록은 함께 갱신해야 한다 — union 에만 추가하면 tsc 는 통과하고 런타임 Set 미등재로
 * 딥링크 착지·리로드 복원만 조용히 깨진다.
 */
export type TeamApprovalsTabId =
  | 'team-leave'
  | 'company-leave'
  | 'corrections'
  | 'company-corrections'
  | 'team-offday'
  | 'company-offday'
  | 'company-all';

const TEAM_APPROVALS_TABS = new Set<string>([
  'team-leave',
  'company-leave',
  'corrections',
  'company-corrections',
  'team-offday',
  'company-offday',
  'company-all',
]);

export function isTeamApprovalsTab(v: unknown): v is TeamApprovalsTabId {
  return typeof v === 'string' && TEAM_APPROVALS_TABS.has(v);
}
